module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-1-0ff35c5e296e89d51d7c669c8b02c040.png";